import { render } from "./TsorQuestionsEdit.vue?vue&type=template&id=8cf7c6b6"
import script from "./TsorQuestionsEdit.vue?vue&type=script&lang=js"
export * from "./TsorQuestionsEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__